// extracted by mini-css-extract-plugin
module.exports = {"custom-button":"buttonSkydropx_custom-button__24X4U"};